import React from "react";
import { css } from "@emotion/react";
import { Card } from "main/javascripts/components/card/Card";
import { RectSkeleton } from "main/javascripts/components/skeleton/RectSkeleton";
import { space } from "main/javascripts/styles/base/spaceStyle";
import { moreThanBreakpoint } from "main/javascripts/styles/base/responsiveStyle";
import { borderColor } from "main/javascripts/styles/base/colorStyle";
import { borderRadius } from "../../../styles/base/borderStyle";

export const CruiseCardSkeleton: React.FC = (): React.ReactElement => {
  return (
    <Card styleKey="cardNoHover">
      <div css={innerStyle}>
        <div css={basicInfoStyle}>
          <div css={imageBlockStyle}>
            <div css={imageSkeletonStyle}>
              <RectSkeleton />
            </div>
          </div>
          <div css={infoBlockStyle}>
            <div css={titleSkeletonStyle}>
              <RectSkeleton />
            </div>
            <div css={dataBlockStyle}>
              <div css={dataSkeletonStyle}>
                <RectSkeleton />
              </div>
              <div css={dataSkeletonStyle}>
                <RectSkeleton />
              </div>
            </div>
          </div>
        </div>
        <div css={scheduleListStyle}>
          <div css={scheduleSkeletonStyle}>
            <RectSkeleton />
          </div>
        </div>
      </div>
    </Card>
  );
};

const innerStyle = css`
  width: 100%;
`;
const basicInfoStyle = css`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  flex: 1;
`;
const imageBlockStyle = css`
  width: 100%;
  box-sizing: border-box;
  padding: ${space.atom2x} ${space.atom2x} ${space.atom};
  ${moreThanBreakpoint("tablet")} {
    height: auto;
    width: 38%;
    padding: ${space.atom2_5x};
    padding-right: 0;
  }
`;
const imageSkeletonStyle = css`
  aspect-ratio: 2 / 1;
  overflow: hidden;
  border-radius: ${borderRadius.normal};
  ${moreThanBreakpoint("tablet")} {
    aspect-ratio: 3 / 2;
  }
`;
const infoBlockStyle = css`
  width: 100%;
  box-sizing: border-box;
  padding: ${space.atom} ${space.atom};
  ${moreThanBreakpoint("tablet")} {
    width: 62%;
    padding: ${space.atom2x} ${space.atom1_5x};
  }
`;
const titleSkeletonStyle = css`
  width: 50%;
  height: 1.5rem;
  margin: ${space.atom1_5x} ${space.atom} ${space.atom};
`;
const dataBlockStyle = css`
  padding: ${space.atom} ${space.atom};
`;
const dataSkeletonStyle = css`
  width: 30%;
  height: 1rem;
  margin: ${space.atom} 0;
`;
const scheduleListStyle = css`
  width: 100%;
  border-top: 1px solid ${borderColor.primaryLightColor};
  padding: ${space.atom2x};
`;
const scheduleSkeletonStyle = css`
  width: 30%;
  height: 1.25rem;
  margin: ${space.atom} 0;
`;
